// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/circle-slash.js';

import { paths } from '../generated/circle-slash';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('circle-slash', Original, paths);
